
import AdminProfilePanel from "../components/admin/AdminProfile";

export default function AdminProfile() {
  return (
    <div>
      <AdminProfilePanel />
    </div>
  );
}
